import styled from "styled-components";
import { 
  Space,
  Button as AntButton,
} from "antd";

// export const SubTitle = styled.div`
//   margin: 0 18px 24px;
//   color: var(--white, #FFF);
//   text-align: center;
//   font-size: 16px;
//   font-style: normal;
//   font-weight: 400;
//   line-height: normal;
// `;

export const StyledInput = styled.input`
	width: 35px !important;
	height: 40px !important;
	border-radius: 12px !important;
	text-align: center !important;
	background: #f4f4f4 !important;
	border: 1px solid ${(props) => (props.status === "error" ? "red" : "#CCC")} !important;
	font-size: 16px !important;
	font-weight: 500;
	-moz-appearance: textfield;
	color: #000000 !important;
	appearance: textfield;
	::-webkit-inner-spin-button,
	::-webkit-outer-spin-button {
		-webkit-appearance: none; /* WebKit */
		margin: 0;
	}
	::-webkit-inner-spin-button:disabled,
	::-webkit-outer-spin-button:disabled {
		display: none;
	}
	@media screen and (max-width: 398px) {
		width: 25px !important;
		height: 30px !important;
    border-radius: 6px !important;
	}
	@media screen and (max-width: 320px) {
		width: 25px !important;
		height: 30px !important;
	}
`;

export const BottomBox = styled(Space)`
  width: 100%;
  margin-top: 6px;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;

`;

export const BottomText = styled(AntButton)`
  cursor: pointer;
  color: #fff !important;
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 26px; /* 162.5% */
  background: none !important;
  border: none !important;
  margin: 0 auto;

  :hover{
    color: #DADADA !important;
    background: none !important;
    border: none;
  }
`;

export const TimeText = styled.div`
  color: #fff;
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 26px; /* 162.5% */
`;


